import Vue from "vue";
import dateFilter from "./date.filter";
import dateTimeFilter from "./datetime.filter";

Vue.filter("date", dateFilter);
Vue.filter("datetime", dateTimeFilter);
